// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"17b8b5e0","110":"e4819274","145":"f603fb46","453":"d855a71b","597":"41d02c95"}[chunkId] + ".chunk.js";
};